import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import _ from "underscore";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import LoadingOverlay from "react-loading-overlay";
import { toast } from "react-toastify";
import cardDetailsService from "../../../services/api/cardDetailsService";
import { cloneCardRequest, cloneSubtaskRequest, updateCardData } from "../../../redux/actions";
import { getAllLanesSelector, getCardDetailsByCardIdSelector } from "../../../redux/selectors";
import { emptyReactionSummary } from "../../../utils/reactions";

const errorConfig = {
  position: "top-center",
  autoClose: false,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "colored",
};

const CloneCard = ({
  open,
  close,
  boardId,
  cards,
  states,
  unselectCards,
  cloneCardAction,
  cloneSubtaskAction,
  updateCardDetailsAction,
  parentCardDetails,
  todoLaneId
}) => {
  // state declarations

  const history = useHistory();

  const [loader, setLoader] = useState(false);

  const handleBulkCloneSubmit = () => {
    // let cardsArr = [...allCards];
    const newCards = [];
    const inputArray = [];
    const selCards = cards;
    let onlysubtask = false;

    for (const i in selCards) {
      if (selCards[i]) {
        const cardObj = selCards[i];
        const newObj = JSON.parse(JSON.stringify(cardObj));
        inputArray.push({
          id: newObj.id,
          tempid: Date.now() + i,
        });
        newObj.id = Date.now() + i;
        newObj.title = cardObj.title.concat(" - copy");
        newObj.reactions = emptyReactionSummary();
        if (newObj.subtask && newObj.stateid !== 1) {
          newObj.state = "To Do";
          newObj.stateid = 1;
          newObj.lane_name = "To Do";
          newObj.lane_id = todoLaneId;
        }
        if (!newObj.subtask) {
          newObj.subtask_done = 0;
          newObj.parent_array = [];
          newObj.childcard_total = 0;
          newObj.childcard_done = 0;
        } else {
          onlysubtask = true;
        }
        newCards.push(newObj);
      }
    }
    cardDetailsService
      .bulkCloneCard({
        ids: inputArray,
        onlysubtask,
      })
      .then(
        (response) => {
          if (response.data.sqlresponse && response.data.sqlresponse.length) {
            newCards.map((item, i) => {
              item.filtered = true;
              const nd = response.data.sqlresponse.filter(
                (card) => parseInt(card.tempid) === parseInt(item.id)
              )[0];
              item.id = parseInt(nd.id);
              let nd_new = nd.cardDetails.filter(i => i.id === nd.id)[0]
              item.description = nd_new.description;
              item.description_image_reference = nd_new.description_image_reference;
            });
          }
          if (onlysubtask) {
            cloneSubtaskAction(newCards);
            // To Update parent card subtask count for cloned subtasks
            if (parentCardDetails && newCards.length > 0) {
              const parentCardId = newCards[0].parent_card;
              const total = {
                subtask_total: parseInt(parentCardDetails.subtask_total) + newCards.length
              };
              const doneSubtasks = newCards.filter(card => card.stateid === 3).length;
              if (doneSubtasks > 0) {
                total.subtask_done = parseInt(parentCardDetails.subtask_done) + doneSubtasks;
              }
              updateCardDetailsAction(parentCardId, total);
            }
          } else {
            cloneCardAction(newCards);
          }
          if (newCards.length === 1) {
            history.push(
              `/board/${boardId}?cardid=${parseInt(newCards[0].id)}`, {
              cloned: true,
              parent_card: newCards[0].parent_card
            });          }

          cancelDialog();
        },
        (error) => {
          const errorMessage =
            error.response.data.message ||
            "Something went wrong. Please contact your Administrator!";
          toast.error(errorMessage, errorConfig);
        }
      );
  };

  const cancelDialog = () => {
    // cards.forEach((element) => {
    unselectCards(cards);
    // })
    close();
  };

  return (
    <Dialog open={open}>
      <DialogTitle id="form-dialog-title">Bulk Clone</DialogTitle>
      <DialogContent>
        <div className="bulkCloneContainer">
          <LoadingOverlay active={loader} spinner text="loading">
            Are you sure, you want to clone {cards.length} card
            {cards.length > 1 ? "s" : ""} ?
          </LoadingOverlay>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={cancelDialog} color="default_button">
          Cancel
        </Button>
        <Button onClick={handleBulkCloneSubmit} color="primary">
          Clone
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = (state, ownProps) => {
  const getalllanes = getAllLanesSelector(state);
  let todoLaneId = null;
  let parentCardDetails;
  // To Get parent card details if we're cloning subtasks
  if (ownProps.cards && ownProps.cards.length > 0 && ownProps.cards[0].subtask && ownProps.cards[0].parent_card) {
    parentCardDetails = getCardDetailsByCardIdSelector(state, ownProps.cards[0].parent_card);
  }
  if( getalllanes && getalllanes.length > 0 && ownProps?.cards[0]?.subtask) {
    todoLaneId = getalllanes.filter(lane => lane.name === "To Do").pop()?.id;
  }
  return {
    parentCardDetails,
    todoLaneId
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      cloneCardAction: (cards) => cloneCardRequest(cards),
      cloneSubtaskAction: (cards) => cloneSubtaskRequest(cards),
      updateCardDetailsAction: (id, data) => updateCardData(id, data),
    },
    dispatch
  );

const CardCloneDialog = connect(mapStateToProps, mapDispatchToProps)(CloneCard);

export default CardCloneDialog;
